// Flag one-shot IN MEMORIA per la copertina post-login.
// Impostato SOLO dopo un login riuscito (invio credenziali / demo).
// Non è persistito: al refresh o al riavvio dell'app torna false,
// così la copertina NON compare al ripristino di sessione o alla navigazione interna.
let pending = false;

export const flagIntro = () => { pending = true; };

// Lettura senza consumo (compatibile con il doppio render di React StrictMode).
export const peekIntro = () => pending;

// Consumo esplicito (da chiamare in un useEffect dopo il mount).
export const clearIntro = () => { pending = false; };
